module.exports = __webpack_public_path__ + "img/xiaoadng_jingpai.7782c9ca.png";